import React from 'react';
import { motion } from 'framer-motion';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';

export const ThemeToggle = ({ className = '' }) => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <motion.button
      onClick={toggleTheme}
      className={`
        relative w-12 h-7 rounded-full p-1 transition-colors duration-200
        ${isDark 
          ? 'bg-neutral-700' 
          : 'bg-neutral-200'
        }
        hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-offset-2
        ${isDark ? 'focus:ring-accent-500 focus:ring-offset-neutral-900' : 'focus:ring-accent-500 focus:ring-offset-white'}
        ${className}
      `}
      whileTap={{ scale: 0.95 }}
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
    >
      <motion.div
        className={`
          w-5 h-5 rounded-full flex items-center justify-center
          ${isDark 
            ? 'bg-neutral-900 text-accent-400' 
            : 'bg-white text-amber-500'
          }
          shadow-sm
        `}
        animate={{ x: isDark ? 20 : 0 }}
        transition={{ type: "spring", stiffness: 500, damping: 30 }}
      >
        <motion.div
          initial={false}
          animate={{ scale: isDark ? 1 : 0, rotate: isDark ? 0 : 180 }}
          transition={{ duration: 0.2 }}
          className="absolute"
        >
          <Moon size={12} />
        </motion.div>
        <motion.div
          initial={false}
          animate={{ scale: isDark ? 0 : 1, rotate: isDark ? 180 : 0 }}
          transition={{ duration: 0.2 }}
          className="absolute"
        >
          <Sun size={12} />
        </motion.div>
      </motion.div>
    </motion.button>
  );
};